import { render, staticRenderFns } from "./SmartTruckPage.vue?vue&type=template&id=76e06a94&"
import script from "./SmartTruckPage.vue?vue&type=script&lang=js&"
export * from "./SmartTruckPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports